import { render, staticRenderFns } from "./dimensionTableDialog.vue?vue&type=template&id=c3b75ca0&scoped=true"
import script from "./dimensionTableDialog.vue?vue&type=script&lang=js"
export * from "./dimensionTableDialog.vue?vue&type=script&lang=js"
import style0 from "./dimensionTableDialog.vue?vue&type=style&index=0&id=c3b75ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b75ca0",
  null
  
)

export default component.exports